import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Switch, FormGroup, FormControlLabel } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import DateFormats from '../../../../elements/DateFormats';
import { MonitoringReportRefreshTimerStyle } from './MonitoringReportRefreshTimer.styles';
import '../../../../FontAwesomeIcons';
import { getIsRefreshTimerActive } from '../redux/selectors/MrdMonitoringSelectors';
import { toggleRefreshTimerActionCreator } from '../redux/actions/MrdMonitoringActions';

function MonitoringReportRefreshTimer({ doRefresh, isRefreshTimerActive, setIsRefreshTimerActive }) {
  const { timezone } = process.env;
  const nowCET = moment().tz(timezone).format(DateFormats.dateTimeWithSeconds);
  const [lastLoad, setLastLoad] = useState(nowCET);
  const [currentTime, setCurrentTime] = useState(nowCET);

  const useStyles = makeStyles(() => ({
    root: {
      width: 80,
      height: 48,
      padding: 8,
    },
    switchBase: {
      padding: 11,
    },
    thumb: {
      width: 26,
      height: 26,
      backgroundColor: '#fff',
    },
    track: {
      background: '#6A6B6B',
      opacity: '1 !important',
      borderRadius: 20,
      position: 'relative',
      '&:before, &:after': {
        display: 'inline-block',
        position: 'absolute',
        top: '50%',
        width: '50%',
        transform: 'translateY(-50%)',
        color: '#fff',
        textAlign: 'center',
      },
      '&:before': {
        content: '"on"',
        left: 4,
        opacity: 0,
      },
      '&:after': {
        content: '"off"',
        right: 4,
      },
    },
    checked: {
      '&$switchBase': {
        transform: 'translateX(32px)',
      },
      '& + $track': {
        '&:before': {
          opacity: 1,
        },
        '&:after': {
          opacity: 0,
        },
      },
    },
  }));

  const refreshReport = () => {
    const current = moment().tz(timezone).format(DateFormats.dateTimeWithSeconds);
    doRefresh();
    setLastLoad(current);
  };

  useEffect(() => {
    const currentTimer = setInterval(() => setCurrentTime(moment().tz(timezone).format(DateFormats.dateTimeWithSeconds)), 1000);
    return () => {
      clearInterval(currentTimer);
    };
  }, []);

  useEffect(() => {
    let refreshTimer;

    if (isRefreshTimerActive) {
      refreshTimer = setInterval(() => refreshReport(), 60000);
    }
    return () => {
      clearInterval(refreshTimer);
    };
  }, [isRefreshTimerActive]);

  const refreshTimerClasses = useStyles();
  return (
    <MonitoringReportRefreshTimerStyle>
      <FormGroup>
        <FormControlLabel
          control={(
            <Switch
              classes={refreshTimerClasses}
              checked={isRefreshTimerActive}
              onChange={() => {
                if (!isRefreshTimerActive) {
                  refreshReport();
                }
                setIsRefreshTimerActive(!isRefreshTimerActive);
              }}
              color="primary"
            />
          )}
          label="Refresh Timer:"
          labelPlacement="start"
        />
      </FormGroup>
      <div>
        <h6 className="monitoring-time">
          <b>Update DateTime (CET): </b>
          <span>{lastLoad}</span>
        </h6>
        <h6 className="monitoring-time">
          <b>Current DateTime (CET): </b>
          <span>{currentTime}</span>
        </h6>
      </div>
    </MonitoringReportRefreshTimerStyle>
  );
}

MonitoringReportRefreshTimer.propTypes = {
  doRefresh: PropTypes.func,
  isRefreshTimerActive: PropTypes.bool,
  setIsRefreshTimerActive: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    isRefreshTimerActive: getIsRefreshTimerActive(state),
  };
}
const mapDispatchToProps = (dispatch) => bindActionCreators({
  setIsRefreshTimerActive: toggleRefreshTimerActionCreator,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MonitoringReportRefreshTimer);
